import React from "react";
import { StickyCta } from "./StepIntro";
import { RadioCard } from "./RadioCard";
import { DisclaimerBanner } from "./DisclaimerBanner";
import {
    PHASE1_QUESTIONS,
    PHASE1_HEADER,
    PHASE1_INTRO,
    PHASE1_SUBMIT_LABEL,
} from "../../lib/content";

/**
 * One Phase-1 question per screen. Verbatim from the export.
 * `phase` is 1 or 2 — reused for Phase 2 dynamic questions too.
 */
export function StepPhase1({ index, answers, onAnswer, onNext, catName }) {
    const q = PHASE1_QUESTIONS[index];
    const value = answers[q.id];
    const isLast = index === PHASE1_QUESTIONS.length - 1;
    const canContinue = Boolean(value);

    return (
        <div className="pb-24" data-testid={`step-phase1-${q.id}`}>
            <div className="mt-2 space-y-2">
                <span className="eyebrow" data-testid="phase-header">{PHASE1_HEADER}</span>
                <p className="text-[13px] leading-relaxed text-meow-muted">
                    {PHASE1_INTRO}
                </p>
            </div>

            <div className="mt-6">
                <h1
                    className="font-display text-[1.6rem] font-medium leading-tight text-meow-charcoal"
                    data-testid="phase1-question-label"
                >
                    {q.label}
                </h1>
                {catName ? (
                    <p className="mt-2 text-[13px] text-meow-muted">
                        About{" "}
                        <span className="font-medium text-meow-charcoal">{catName}</span>
                    </p>
                ) : null}
            </div>

            <div className="mt-5 space-y-2.5" role="radiogroup" data-testid={`phase1-options-${q.id}`}>
                {q.options.map((opt, i) => (
                    <RadioCard
                        key={opt}
                        value={opt}
                        label={opt}
                        checked={value === opt}
                        onSelect={(v) => onAnswer(q.id, v)}
                        testId={`phase1-${q.id}-opt-${i}`}
                    />
                ))}
            </div>

            <div className="mt-6">
                <DisclaimerBanner />
            </div>

            <StickyCta>
                <button
                    type="button"
                    className="meow-btn-primary w-full"
                    disabled={!canContinue}
                    onClick={onNext}
                    data-testid="phase1-next-btn"
                >
                    {isLast ? PHASE1_SUBMIT_LABEL : "Next question"}
                </button>
            </StickyCta>
        </div>
    );
}
